import React from 'react';
import PropTypes from 'prop-types';

import './LinkCard.scss';

import BROWSE_VEHICLES from '../../assets/images/icons/linkCard_evs.svg';
import COMPARE_VEHICLES from '../../assets/images/icons/linkCard_explore.svg';
import DISCOVER_INCENTIVES from '../../assets/images/icons/linkCard_incentives.svg';
import COMPARE_RATES from '../../assets/images/icons/linkCard_rates.svg';
import FIND_CHARGING from '../../assets/images/icons/linkCard_charging.svg';

import { Link } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';

const LinkCard = ({ type }) => {
  const intl = useIntl();
  let id, src, link, button_title;
  const mobile = window.innerWidth < 720;

  switch (type) {
    case 'BROWSE_VEHICLES':
      id = 'browseVehicles';
      src = BROWSE_VEHICLES;
      link = '/vehicles';
      button_title = intl.formatMessage ? (
        !mobile ? (
          intl.formatMessage({
            id: 'homepage.browse.v2',
            defaultMessage: 'Browse EVs',
          })
        ) : (
          <FormattedMessage
            id="homepage.browse.mobile.v2"
            defaultMessage="Browse EVs"
          />
        )
      ) : (
        'Discover Electric Vehicles'
      );
      break;
    case 'COMPARE_VEHICLES':
      id = 'compareVehicles';
      src = COMPARE_VEHICLES;
      link = '/compare-vehicles';

      button_title = intl.formatMessage
        ? intl.formatMessage({
            id: 'homepage.compare',
            defaultMessage: 'Explore EV Ownership',
          })
        : 'Explore EV Ownership';
      break;
    case 'DISCOVER_INCENTIVES':
      id = 'discoverIncentives';
      src = DISCOVER_INCENTIVES;
      link = '/incentives';
      button_title = intl.formatMessage
        ? intl.formatMessage({
            id: 'homepage.incentives',
            defaultMessage: 'Maximize Incentives',
          })
        : 'Maximize Incentives';
      break;
    case 'COMPARE_RATES':
      id = 'compareRates';
      src = COMPARE_RATES;
      link = '/rates';
      button_title = intl.formatMessage
        ? intl.formatMessage({
            id: 'homepage.billSavings',
            defaultMessage: 'Bill Savings',
          })
        : 'Bill Savings';
      break;
    case 'FIND_CHARGING':
      id = 'findCharging';
      src = FIND_CHARGING;
      link = '/charging-stations';
      button_title = intl.formatMessage
        ? intl.formatMessage({
            id: 'homepage.charging',
            defaultMessage: 'Find Charging',
          })
        : 'Find Charging';
      break;

    default:
      return null;
  }

  return (
    <div className="link-card" id={id}>
      <Link to={link} className="evc-card">
        <img src={src} alt="" className="evc-card-image" />
        <button className="btn btn-homepage">{button_title}</button>
      </Link>
    </div>
  );
};

export default LinkCard;

LinkCard.propTypes = {
  type: PropTypes.string,
};
